import { AppVariants } from "common/types/appVariant";

import useIsGoStudentLearningApp from "features/goStudentLearning/hooks/useIsGoStudentLearningApp";
import { useIsPlurallApp } from "features/plurall";
import { useIsPrimaryApp } from "features/primary/hooks";

export default function useAppVariant() {
  const isPlurallApp = useIsPlurallApp();
  const isGoStudentLearningApp = useIsGoStudentLearningApp();
  const isPrimaryApp = useIsPrimaryApp();

  if (isPlurallApp) return AppVariants.plurall;
  if (isGoStudentLearningApp) return AppVariants.goStudentLearning;
  if (isPrimaryApp) return AppVariants.senecaPrimary;

  return AppVariants.seneca;
}
